import { apiCall } from './gqlClient';

const GETCASHREVENUE_QUERY = `
  query getCashRevenue($from: String!, $to: String!) {
    getCashRevenue(from: $from, to: $to)
    {
      cashRevenueCents
      ...fragments
    }
  }`;

export const getCashRevenueApiCall = async ({from, to}, fragments = null) => apiCall({ query: GETCASHREVENUE_QUERY, variables: {from, to}, fragments });

const GETCREDITCONSUMED_QUERY = `
  query getCreditConsumed($from: String!, $to: String!) {
    getCreditConsumed(from: $from, to: $to)
    {
      creditConsumedCents
      ...fragments
    }
  }`;

export const getCreditConsumedApiCall = async ({from, to}, fragments = null) => apiCall({ query: GETCREDITCONSUMED_QUERY, variables: {from, to}, fragments });

const GETCOLLECTEDPAYMENTS_QUERY = `
  query getCollectedPayments($from: String!, $to: String!, $method: String) {
    getCollectedPayments(from: $from, to: $to, method: $method)
    {
      eventId
			orderId
			created
			amountCents
			type
			method
			channel
			netCents
			taxCents
			grossCents
			userId
			customerId
      ...fragments
    }
  }`;

export const getCollectedPaymentsApiCall = async ({from, to, method}, fragments = null) => apiCall({ query: GETCOLLECTEDPAYMENTS_QUERY, variables: {from, to, method}, fragments });

const RECONCILECASHREVENUE_QUERY = `
  query reconcileCashRevenue($from: String!, $to: String!) {
    reconcileCashRevenue(from: $from, to: $to)
    {
      ledgerCashCents
			legacyPaidCents
			deltaCents
      ...fragments
    }
  }`;

export const reconcileCashRevenueApiCall = async ({from, to}, fragments = null) => apiCall({ query: RECONCILECASHREVENUE_QUERY, variables: {from, to}, fragments });

const GETWALLETLEDGERSUMMARY_QUERY = `
  query getWalletLedgerSummary($from: String!, $to: String!) {
    getWalletLedgerSummary(from: $from, to: $to)
    {
      topupCashCents
			bonusGrantedCents
			reimbursedCents
			consumedCents
			netCents
      ...fragments
    }
  }`;

export const getWalletLedgerSummaryApiCall = async ({from, to}, fragments = null) => apiCall({ query: GETWALLETLEDGERSUMMARY_QUERY, variables: {from, to}, fragments });

const RECONCILEWALLETBALANCE_QUERY = `
  query reconcileWalletBalance($walletId: String!) {
    reconcileWalletBalance(walletId: $walletId)
    {
      walletId
			columnCents
			ledgerCents
			deltaCents
			reconciled
      ...fragments
    }
  }`;

export const reconcileWalletBalanceApiCall = async ({walletId}, fragments = null) => apiCall({ query: RECONCILEWALLETBALANCE_QUERY, variables: {walletId}, fragments });

const RECONCILEWALLETBALANCES_QUERY = `
  query reconcileWalletBalances {
    reconcileWalletBalances
    {
      walletId
			columnCents
			ledgerCents
			deltaCents
      ...fragments
    }
  }`;

export const reconcileWalletBalancesApiCall = async (fragments = null) => apiCall({ query: RECONCILEWALLETBALANCES_QUERY, variables: {}, fragments });

const RECONCILEMEMBERSHIPBALANCE_QUERY = `
  query reconcileMembershipBalance($userMembershipId: Int!) {
    reconcileMembershipBalance(userMembershipId: $userMembershipId)
    {
      userMembershipId
			counterType
			columnUnits
			ledgerUnits
			deltaUnits
			reconciled
      ...fragments
    }
  }`;

export const reconcileMembershipBalanceApiCall = async ({userMembershipId}, fragments = null) => apiCall({ query: RECONCILEMEMBERSHIPBALANCE_QUERY, variables: {userMembershipId}, fragments });

const RECONCILEMEMBERSHIPBALANCES_QUERY = `
  query reconcileMembershipBalances {
    reconcileMembershipBalances
    {
      userMembershipId
			counterType
			columnUnits
			ledgerUnits
			deltaUnits
      ...fragments
    }
  }`;

export const reconcileMembershipBalancesApiCall = async (fragments = null) => apiCall({ query: RECONCILEMEMBERSHIPBALANCES_QUERY, variables: {}, fragments });
